import {Component,} from '@angular/core';
import {MatDialog,} from '@angular/material/dialog';
import {LoginInfoService, WindowService,} from '@services/index';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss',
  ],
})
export class HeaderComponent {

  constructor(public loginInfo: LoginInfoService,
              public windowService: WindowService,
              public dialog: MatDialog) {

    // キー抑止
    window.document.onkeydown = ((event: KeyboardEvent) => {
      // console.log('isAltKey:', event.altKey);
      // console.log('Key:', event.key);

      // ALT + ← → d 抑止
      if (event.altKey) {
        if (event.key === 'ArrowLeft' || event.key === 'Left' || event.key === 'ArrowRight' || event.key === 'Right' || event.key === 'd') {
          event.preventDefault();
          return false;
        }
      }
      if (event.ctrlKey) {
        // CTRL + d 抑止
        if (event.key === 'd') {
          event.preventDefault();
          return false;
        } else if (event.key === 'r') {
          // CTRL + r 抑止
          event.preventDefault();
          return false;
        }
      }

      // F5 抑止
      // eslint-disable-next-line import/no-deprecated
      if (event.key === 'F5') {
        event.preventDefault();
        return false;
      }

      return true;
    });

    // 右クリックメニュー抑制
    document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    }, false);

    // 戻るボタン抑制
    history.pushState(null, '', null);
    window.addEventListener('popstate', () => {
      history.pushState(null, '', null);
      return;
    });

  }
}
